<div class="left-container-toolbar">
  @if (isStandardView) {
    <button (click)="exportItems()" class="primary" type="button">
      {{ "generic.buttons.export" | translate }}
    </button>
  }
</div>
<div class="right-container-toolbar">
  @if (isStandardView) {
    <app-search-bar [(value)]="searchValue" [data]="data" [filters]="filters" />
  }
</div>
